module.exports = __webpack_public_path__ + "static/elephant-720-c496d2d9ff23cae46005c1bdf6e64084.webm";